import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const Eye: React.FC<IIconProps> = ({
  size = IconSizes.md,
  color = '#83807F',
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      width={IconWidth[size]}
      height={IconHeight[size]}
      viewBox="0 0 19 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={UNSAFE_className || ''}
      {...props}
    >
      <g xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18.9296 11.9778C18.78 11.7142 15.1842 5.5415 9.49992 5.5415C4.62238 5.5415 0.276058 11.6788 0.0931804 11.9404C-0.0311008 12.1187 -0.0311008 12.3803 0.0931804 12.5595C0.276058 12.8211 4.62238 18.9584 9.49992 18.9584C14.3775 18.9584 18.7237 12.8211 18.9066 12.5595C19.0214 12.3947 19.0317 12.156 18.9296 11.9778ZM9.49992 18.0001C5.58983 18.0001 1.87208 13.4862 0.927635 12.25C1.87052 11.0128 5.5843 6.49988 9.49992 6.49988C14.075 6.49988 17.3043 11.007 18.0928 12.2241C17.1823 13.4211 13.4433 18.0001 9.49992 18.0001Z"
          fill={color}
        />
        <path
          d="M9.4999 8.4165C7.75347 8.4165 6.33319 10.1358 6.33319 12.2499C6.33319 14.364 7.75347 16.0833 9.4999 16.0833C11.2463 16.0833 12.6666 14.364 12.6666 12.2499C12.6666 10.1358 11.2463 8.4165 9.4999 8.4165ZM9.4999 15.125C8.19047 15.125 7.12486 13.835 7.12486 12.2499C7.12486 10.6648 8.19047 9.37488 9.4999 9.37488C10.8093 9.37488 11.8749 10.6648 11.8749 12.2499C11.8749 13.835 10.8093 15.125 9.4999 15.125Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default Eye;
